interface MetasearchDiscountSelectorContext {
  enabled: boolean
  requestKey?: string
}

export function getMetasearchDiscountAmount(
  state: App.State,
  context: MetasearchDiscountSelectorContext,
): number {
  if (!context.enabled || !context.requestKey) {
    return 0
  }

  if (state.marketing.metasearchDiscount.requestKey !== context.requestKey) {
    return 0
  }

  if (state.marketing.metasearchDiscount.error) {
    return 0
  }

  return Math.max(state.marketing.metasearchDiscount.discountAmount ?? 0, 0)
}
